/**
 * Đọc/ghi lựa chọn giao diện và áp lên tài liệu.
 *
 * Luật ở đây phải TRÙNG với script inline chống nháy trắng trong public/index.html.
 * Script đó chạy trước khi React mount; từ lúc ThemeProvider gắn vào thì file này
 * là nơi duy nhất cập nhật class/meta.
 */

export const THEME_KEY = 'lh-theme';

/** 3 mức người dùng chọn được */
export const THEME_MODES = ['system', 'light', 'dark'];

export const THEME_LABELS = {
    system: 'Theo hệ thống',
    light: 'Sáng',
    dark: 'Tối',
};

/** Màu thanh địa chỉ trình duyệt (meta theme-color) — khớp --surface của mỗi chế độ */
const THEME_COLOR = { light: '#FFFFFF', dark: '#020617' };

export function getMode() {
    try {
        const saved = localStorage.getItem(THEME_KEY);
        return THEME_MODES.includes(saved) ? saved : 'system';
    } catch {
        // Chế độ ẩn danh / chặn cookie có thể ném khi đọc localStorage
        return 'system';
    }
}

export function setMode(mode) {
    try {
        localStorage.setItem(THEME_KEY, mode);
    } catch {
        // Không lưu được thì vẫn cho đổi trong phiên hiện tại
    }
}

export function prefersDark() {
    return (
        typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-color-scheme: dark)').matches
    );
}

/** Quy đổi lựa chọn + cài đặt hệ điều hành → có phải chế độ tối không */
export function resolveDark(mode) {
    if (mode === 'dark') return true;
    if (mode === 'light') return false;
    return prefersDark();
}

/** Áp chế độ lên thẻ <html>: class, color-scheme và meta theme-color */
export function applyTheme(mode) {
    const dark = resolveDark(mode);
    const root = document.documentElement;

    root.classList.toggle('dark', dark);
    // color-scheme để thanh cuộn, ô chọn ngày, autofill của trình duyệt tối theo
    root.style.colorScheme = dark ? 'dark' : 'light';

    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', dark ? THEME_COLOR.dark : THEME_COLOR.light);

    return dark;
}
